import { installRecoverableHydrationWarningReporter } from '@/utils/newRelic/recoverableHydrationWarning'

// Next loads client instrumentation before it captures `reportError` for its
// React `onRecoverableError` callback, so install the wrapper before hydration.
installRecoverableHydrationWarningReporter()
